import { ThemesSuffix } from '@enums/themes';
import { Theme } from '@models/theme';

export const Themes: Theme[] = [
  {
    id: ThemesSuffix.THEME_BLACK,
    name: 'views.settings.themes.black',
    cssClass: 'eld-theme__' + ThemesSuffix.THEME_BLACK,
  },
  {
    id: ThemesSuffix.THEME_LIGHT,
    name: 'views.settings.themes.light',
    cssClass: 'eld-theme__' + ThemesSuffix.THEME_LIGHT,
  },
];
